import React from "react";
import { Component } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Constants from "../../helpers/Constants";
import authService from "../../services/AuthorizeService";

export default class AuthorizeRoute extends Component<any, any> {

  private _subscription = 0;

  constructor(props: any) {
    super(props);

    this.state = {
      ready: false,
      authenticated: false,
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() =>
      this.authenticationChanged()
    );
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  render() {
    const { ready, authenticated } = this.state;
    var link = document.createElement("a");
    link.href = window.location.href;
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    const redirectUrl = `${Constants.ApplicationPaths.Login}?${Constants.QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;
    if (!ready) {
      return <div></div>;
    } else {
      //console.log(redirectUrl);
      return authenticated ? <Outlet /> : <Navigate to={redirectUrl} />;
    }
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated });
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }
}
